import { render, staticRenderFns } from "./Checkbox.form-builder.vue?vue&type=template&id=615a9e4d&scoped=true&"
import script from "./Checkbox.form-builder.vue?vue&type=script&lang=js&"
export * from "./Checkbox.form-builder.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox.form-builder.vue?vue&type=style&index=0&id=615a9e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a9e4d",
  null
  
)

export default component.exports